const PageBanner = ({ title, backgroundComponent: BackgroundComponent }) => {
  return (
    <div className="relative flex items-center justify-center h-40 text-center bg-primary-100 overflow-hidden">
      {BackgroundComponent && (
        <div className="absolute inset-0 w-full h-full z-0 pointer-events-none">
          <BackgroundComponent className="w-full h-full" />
        </div>
      )}
      <div
        className="relative z-10 text-3xl font-bold bg-gradient-primary bg-clip-text"
        style={{ WebkitTextFillColor: 'transparent' }}
      >
        {title}
      </div>
    </div>
  );
};

export default PageBanner;
